import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useAccessToken } from '@/auth/hooks/useAccessToken';
import { useLogin } from '@/auth/hooks/useAuth.ts';
import background from '/Background.png';

import { Form, FormField, FormItem, FormControl, FormMessage } from '@/components/ui/form';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

type LoginFormValues = {
  email: string;
  password: string;
};

export function LoginForm() {
  const form = useForm<LoginFormValues>();
  const navigate = useNavigate();
  const useToken = useAccessToken();
  const { mutate: login, error } = useLogin();

  const onSubmit = (data: LoginFormValues) => {
    login(data, {
      onSuccess: ({ accessToken }) => {
        useToken.setToken(accessToken);
        navigate('/');
      },
    });
  };

  return (
    <>
      <img src={background} alt="Background" className="w-screen h-screen absolute object-cover blur-lg" />
      <div className="flex flex-col bg-content-dark rounded-3xl z-10 h-96 w-96 shadow-lg shadow-black/30">
        <div className="flex justify-center items-center bg-content-dark rounded-t-3xl p-5 mb-5">
          <h2 className="text-3xl font-bold text-white mx-auto ">Zubee Factory</h2>
        </div>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col gap-4 z-10 p-10">
            <FormField
              control={form.control}
              name="email"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <Input type="text" {...field} placeholder="Email" required />
                  </FormControl>
                  {form.formState.errors.email && <FormMessage>{form.formState.errors.email.message}</FormMessage>}
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="password"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <Input type="password" {...field} placeholder="Password" required />
                  </FormControl>
                  {form.formState.errors.password && <FormMessage>{form.formState.errors.password.message}</FormMessage>}
                </FormItem>
              )}
            />
            {error && <div>Invalid email or password</div>}
            <Button type="submit" size={'lg'} className={'mt-5 font-bold'}>
              LOGIN
            </Button>
          </form>
        </Form>
      </div>
    </>
  );
}
